// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"57a492f0","209":"42440330","240":"9025c8b4","274":"4156c3f5","372":"e2ba7b7d","509":"17fceab7","680":"70d3b497","794":"3bc62402","804":"d2337e06"}[chunkId] + ".chunk.js";
};